import * as React from 'react';
import { FC } from 'react';
import type { Campaign } from 'app/CasinoGames/useJackpotAggregatorCampaigns';
import JackpotAggregatorWinnerWins from 'app/JackpotAggregatorWinnerWins';
import useWins from 'app/JackpotAggregatorWinnerWins/useWins';
import locales from 'app/CasinoGames/locales';
import type { Game } from 'app/CasinoGames/types';
import isGameWithJackpot from 'app/CasinoGames/isGameWithJackpot';
import type { Fullscreen } from './useFullscreen';
import Timer from './Timer';
import JackpotsAndWins from './JackpotsAndWins';

const FullscreenButton: FC<{ fullscreen: Fullscreen }> = ({ fullscreen }) => (
  <a className="control" onClick={fullscreen.enabled ? fullscreen.disable : fullscreen.enable}>
    <img
      src={`/images/gameui/fullscreen${fullscreen.enabled ? '-exit' : ''}.svg`}
      alt="full screen"
      title="full screen"
    />
  </a>
);

const CloseButton: FC<{ onClose: () => void }> = ({ onClose }) => (
  <a className="control close" onClick={() => onClose()}>
    <img src="/images/gameui/close.svg" alt="close game" title="close game" />
  </a>
);

const Sidebar: FC<{
  game: Game;
  fullscreen: Fullscreen;
  onClose: () => void;
  jackpotAggregatorCampaigns: Campaign[];
}> = ({ game, fullscreen, onClose, jackpotAggregatorCampaigns }) => {
  const [win] = useWins();
  const l = locales();
  const withJackpot = isGameWithJackpot(game.type);

  return (
    <div className="sidebar" aria-label="sidebar">
      <Timer />
      {withJackpot && !win && <JackpotsAndWins campaigns={jackpotAggregatorCampaigns} />}
      <div className="logo" />
      {withJackpot && <JackpotAggregatorWinnerWins locales={l} />}
      <div className="controls">
        {fullscreen.available && <FullscreenButton fullscreen={fullscreen} />}
        <CloseButton onClose={onClose} />
      </div>
    </div>
  );
};

export default Sidebar;
